const ContentFormDataErrorDefault: any = {
    title: {
        error: false,
        errorText: ""
    },
    content: {
        error: false,
        errorText: ""
    },
    optionsContent: {
        error: false,
        errorText: ""
    },
    correctAnswer: {
        error: false,
        errorText: ""
    },
    subjects: {
        error: false,
        errorText: ""
    },
    stepWiseSolution: {
        error: false,
        errorText: ""
    },
    tags: {
        error: false,
        errorText: ""
    },
    questions: []
}

export default ContentFormDataErrorDefault;